import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../redux/store";
import { logoutUser } from "../redux/slices/authSlice";

function useDetectSession() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const logout = (idToken: string) => {
    const checkIdToken = localStorage.getItem("idToken") ?? "";
    const data = { uid: idToken };

    if (!idToken || checkIdToken === "") {
      navigate("/login");
      return;
    }

    dispatch(logoutUser(data))
      .unwrap()
      .then(() => {
        navigate("/login");
        localStorage.removeItem("idToken");
      });
  };

  const idToken = localStorage.getItem("idToken") ?? "";
  const [isUserInactive, setIsUserInactive] = useState<boolean>(false);

  const localStore: any = localStorage.setItem;

  localStorage.setItem = function (key: string, value: string) {
    const event: any = new Event("localUpdated");
    event.key = key;
    event.value = value;

    document.dispatchEvent(event);
    localStore.apply(this, arguments);
  };

  const localStoreHandler = function (e: any) {
    if (
      (e.key === "userTimeOut" && e.value === "true") ||
      (e.key === "idToken" && !e.value)
    ) {
      setIsUserInactive(true);
    } else {
      setIsUserInactive(false);
    }
  };

  document.addEventListener("localUpdated", localStoreHandler, false);

  useEffect(() => {
    if (isUserInactive) {
      try {
        logout(idToken);
      } catch (_error) {}
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, idToken, navigate, isUserInactive]);
}

export default useDetectSession;
